import React, { FC, ReactNode, MouseEvent } from "react";
import { useAppSelector } from "../../store";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import {
  StyledModal,
  AuthCard,
  BannerImg,
  Headline,
  LoginButton,
  SignupButton,
  SocialRow,
  SocialButton,
  Divider,
  StayLoggedOut,
} from "./styled";

interface AuthGuardProps {
  children: ReactNode;
  onAuthRequired?: () => void;
}

const AuthGuard: FC<AuthGuardProps> = ({ children, onAuthRequired }) => {
  const { me } = useAppSelector((state) => state.authReducer);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const navigate = useNavigate();

  const handleAuthCheck = () => {
    if (!me) {
      setIsModalVisible(true);
      if (onAuthRequired) {
        onAuthRequired();
      }
      return false;
    }
    return true;
  };

  const handleLogin = () => {
    setIsModalVisible(false);
    navigate("/login");
  };

  const handleSignup = () => {
    setIsModalVisible(false);
    navigate("/signup");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const wrappedChildren = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      const element = child as React.ReactElement<{
        onClick?: (e: MouseEvent) => void;
      }>;
      return React.cloneElement(element, {
        onClick: (e: MouseEvent) => {
          if (!handleAuthCheck()) {
            e.preventDefault();
            e.stopPropagation();
          }
          if (element.props.onClick) {
            element.props.onClick(e);
          }
        },
      });
    }
    return child;
  });

  return (
    <>
      {wrappedChildren}
      <StyledModal
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
        width={420}
      >
        <AuthCard>
          <BannerImg
            src="https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=600&q=80"
            alt="Banner"
          />
          <Headline>Join us or log in to keep going.</Headline>
          <div
            style={{
              padding: "24px",
              gap: "16px",
              display: "flex",
              flexDirection: "column",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <LoginButton onClick={handleLogin}>Log in</LoginButton>
            <SignupButton onClick={handleSignup}>Sign up</SignupButton>
            <StayLoggedOut onClick={handleCancel}>
              Stay logged out
            </StayLoggedOut>
          </div>
        </AuthCard>
      </StyledModal>
    </>
  );
};

export default AuthGuard;
